import { Event } from './event-bus';

export interface Events {
    navigate: Event<{path: string, params?: Record<string, any>}>;
    appHistory: Event<{path: string}>;
    showNotification: Event<{state: string}>
}
